<template>
  <div>
    <el-form :model="courseInfo" ref="addCourseModel">
      <el-form-item label="课程名称" label-width="100px" prop="Title">
        <el-input v-model="courseInfo.Title"></el-input>
      </el-form-item>
      <el-form-item label="课程类型" label-width="100px" prop="Type">
        <el-radio-group v-model="courseInfo.Type" @change="courseTypeChange">
          <el-radio v-for="item in this.courseTypeList" :label="item.value"  v-bind:disabled="!isAdd">{{item.label}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="最大人数" label-width="100px">
        <el-radio-group v-if="courseInfo.Type === 0" v-model="courseInfo.MaxUserNum">
          <el-radio v-for="item in this.miniClassUserNumList" :label="item.value">{{item.label}}</el-radio>
        </el-radio-group>
        <el-input-number v-else v-model="courseInfo.MaxUserNum" :min="1" :max="maxUserCeil" label="最大人数" style="width: 200px"></el-input-number>

      </el-form-item>
      <el-form-item label="课程有效期" label-width="100px">
        <el-date-picker
          v-model="courseInfo.Expire"
          type="datetime"
          placeholder="选择日期时间"
          style="width: 200px">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="课程封面" label-width="100px">
        <el-upload
          class="avatar-uploader"
          name="qianxue"
          action='string'
          list-type="picture-card"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="consoleFL">
          <img v-if="courseInfo.HeadImg" :src="courseInfo.HeadImg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>

      </el-form-item>
      <el-form-item label="课程描述" label-width="100px">
        <el-input v-model="courseInfo.Detail"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"></el-input>
      </el-form-item>
    </el-form>
    <div style="padding-top: 10px;padding-left: 30px">
      <el-button @click="cancleBtnClick">取 消</el-button>
      <el-button type="primary" @click="okBtnClick">确 定</el-button>
    </div>

     <el-dialog :visible.sync="cropperModel" width="1100px"  append-to-body :close-on-click-modal="false">
                <Cropper :img-file="fileurl" :skuname="skufilekey" ref="vueCropper" @upload="uploadImg">
                </Cropper>
              </el-dialog>
  </div>
</template>

<script>
import Cropper from '../utils/cropper.vue'
export default {
  name: 'CourserInfoComponent',
  components:{Cropper},
  props: {
    courseInfo: {
      required: false
    },
    isAdd: {
      default: true
    }
  },
  data () {
    return {
      courseTypeList: [{label: '小班课', value: 0}, {label: '大班课', value: 1}, {label: '双师课', value: 5}],
      miniClassUserNumList: [{label: '1对1', value: 2}, {label: '1对6', value: 6}],
      maxUserCeil: 25,
      cropperModel: false,
      skufilekey: '',
      fileurl: '',
      file: null
    }
  },
  methods: {
    consoleFL (file, fileList) {
      this.file = file
      console.log(this.fileurl)
      this.skufilekey = ''
      this.cropperModel = true

       // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.fileurl = file.url
      })
    },
    okBtnClick () {
      this.$emit('OKBtnClick')
    },
    cancleBtnClick () {
      this.$emit('CancleBtnClick')
    },
    courseTypeChange () {
      this.maxUserCeil = this.getMaxUserByType(this.courseInfo.Type)
      if (this.courseInfo.Type === 0 && this.courseInfo.MaxUserNum > this.getMaxUserByType(0)) {
        this.courseInfo.MaxUserNum = this.getMaxUserByType(0)
      }
    },
    getMaxUserByType (courseType) {
      switch (courseType) {
        case 0 :
          return 25
        default:
          return Infinity
      }
    },
    uploadImg: function (data, key) {
      let formData = new FormData()
      formData.append('qianxue', data, this.file.name)
      this.$api.uploadManager.uploadFile(formData).then((res) => {
        this.courseInfo.HeadImg = res.url
        this.cropperModel = false
      })
    },
    handleAvatarSuccess (res, file) {
      console.log('res====', res)
    },
    beforeAvatarUpload (file) {
      let types = ['image/jpeg', 'image/png']
      const isImage = types.includes(file.type)
      if (!isImage) {
        this.$message.error('请上传jpeg、png格式图片')
        return false
      }
      if (file.size / 1024 / 1024 > 3) {
        this.$message.error('最大上传3M')
        return false
      }
      let uploadParam = new FormData()
      uploadParam.append('qianxue', file)
      this.$api.uploadManager.uploadFile(uploadParam).then((res) => {
        this.courseInfo.HeadImg = res.url
      })
      return false
    }
  }
}
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
/*    border: 1px dashed #d9d9d9; */
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/course/CourserInfoComponent.vue